import React from 'react';
import ImageDisplayCards from '../ImageDisplayCards';
import { Typography } from '@mui/material';

function RenderImageUpload({ input, meta: { invalid, touched, error }, ...custom }) {
	return (
		<div className={custom.inputdata.customClass ?? ''}>
			{custom.inputdata.label && (
				<Typography variant="subtitle1" style={{ marginBottom: '8px' }}>
					{custom.inputdata.label}
				</Typography>
			)}      
			<ImageDisplayCards
				label={custom.inputdata.label}
				onRef={custom.onRef}
				id={custom.inputdata.id}
				accept={custom.inputdata.accept ? custom.inputdata.accept : 'image/*'}
				name={custom.inputdata.name}
				onChange={(value) => {
					input.onChange(value);
					if (typeof custom.inputdata.onChange !== 'undefined') {
						custom.inputdata.onChange(value);
					}
				}}
				error={error}
				invalid={invalid}
				validate={custom.inputdata.validate}
				alert={custom.inputdata.alert}
        layout={custom.inputdata.layout}
				initialFiles={custom.inputdata.initialFiles}
				limitFiles={custom.inputdata.limitFiles}
				uploadEnabled={typeof custom.inputdata.uploadEnabled === 'undefined' || custom.inputdata.uploadEnabled ? true : false}
        videoResolutionsAllowed={custom.videoResolutionsAllowed}
			/>
		</div>
	);
}

export default RenderImageUpload;
